// extracted by mini-css-extract-plugin
export default {"container":"JjMVJhkOmgsQy6D41vhI","title":"W7loqflKjmyQ2jnj6pZp","description":"r_Y7ANtOK_4DRBxnrnaA","profilelist":"WGecA557ZhW1OT7u5BQo","digitfocus":"wTutY7AtHg0XwTnRsiZh"};